import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { allowedTableCellPropTypes } from '../utils/allowedPropTypes';
import DefinitionList from './_DefinitionList';

const DefinitionListCollection = ({ listCollectionData }) => (
  <ul className='ul-table-child'>
    {listCollectionData.map(listData => (
      <li key={uuidv4()}>
        <DefinitionList listData={listData} />
      </li>
    ))}
  </ul>
);

DefinitionListCollection.propTypes = {
  listCollectionData: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape(allowedTableCellPropTypes)
    )
  ).isRequired
};

export default DefinitionListCollection;